module.exports = __webpack_public_path__ + "img/logo (10).919246b8.png";